<template>
  <div class="container">
    <template v-for="item, idx in gData" :key="idx">
      <TwoUpFiveDown :items="item[0]"></TwoUpFiveDown>
      <OneLeftSixRight :items="item[1]"></OneLeftSixRight>
    </template>
    <!-- <TenBlocks></TenBlocks>
      <OnlyTwo></OnlyTwo>
      <OnlyFive></OnlyFive> -->
  </div>
</template>

<script>
import TwoUpFiveDown from "./components/twoUpFiveDown.vue";
import OneLeftSixRight from "./components/oneLeftSixRight.vue";
// import TenBlocks from "./components/tenBlocks.vue";
// import OnlyTwo from "./components/onlyTwo.vue";
// import OnlyFive from "./components/onlyFive.vue";

export default {
  name: "App",
  components: {
    TwoUpFiveDown,
    OneLeftSixRight,
    // TenBlocks,
    // OnlyTwo,
    // OnlyFive,
  },
  data() {
    return {
      windowY: 0,
      currentY: 0,
      isAtBottom: false,
      dueToBottomGap: window.innerHeight / 2,
      pids: null,
      page: 0,
      totalPage: 0, //總頁數
      isApiOk: true,
      gData: [],
    };
  },
  async created() {
    window.addEventListener("scroll", this.handleScroll, {
      passive: true,
    });
    const promotionId = window.promotionId;
    this.pids = await this.getPidsByPromotionId(promotionId);
    this.getSearchBatch();
  },
  methods: {
    handleScroll() {
      const wy = window.scrollY;
      this.windowY = wy;
      this.currentY = wy !== 70 && wy !== 0 ? wy : this.currentY;
      if (
        window.innerHeight + wy + this.dueToBottomGap >=
        document.body.scrollHeight
      ) {
        this.isAtBottom = true;
      } else {
        this.isAtBottom = false;
      }
    },
    async getPidsByPromotionId(promotionId) {
      const data = await this.axios
        .get(
          `https://front.shopping.friday.tw/frontendapi/ai/promotion/gather/${promotionId}`
        )
        .then((res) => {
          const { data, status } = res;
          if (status === 200 && data && data.resultCode !== 800) {
            const { resultData } = data;
            if (typeof resultData.value === "string") {
              const pids = resultData.value.split(",");
              return pids;
            }
          }
        });
      return data;
    },
    getSearchBatch() {
      let pidArr;
      let allpostData;
      let fetchData;

      pidArr = this.pids;
      if (pidArr && pidArr.length > 0) {
        this.totalPage =
          pidArr.length % 14 !== 0
            ? Math.floor(pidArr.length / 14 + 1)
            : Math.floor(pidArr.length / 14);
        allpostData = pidArr.map((pid) => {
          return { pid, cid: 0 };
        });
        // console.log(allpostData);
        this.isApiOk = false;
        fetchData = allpostData.slice(this.page * 14, (this.page + 1) * 14);
        this.axios({
          method: "POST",
          url: `https://m.shopping.friday.tw/mobileapi/api/product/search/batch`,
          data: fetchData,
        }).then((res) => {
          const { data } = res;
          if (data && data.payload && data.payload.length > 0) {
            const d = data.payload[0].products;
            const dArr = d.map(
              ({ image_url, name, list_price, price, pid, promotion }) => ({
                image_url,
                name,
                list_price,
                price,
                pid,
                promotion,
              })
            );
            let dualArr = [];
            dualArr.push(dArr.slice(0, 7), dArr.slice(7));
            this.gData.push(dualArr);
            this.$nextTick(() => {
              if (this.page < this.totalPage) {
                this.page += 1;
                this.isApiOk = true;
                this.isAtBottom = false;
              }
            });
          }
        });
      }
    },
  },
  watch: {
    isAtBottom(newVal) {
      // gData.length > 0 為取得集合目錄資料
      if (
        this.gData.length > 0 &&
        this.page < this.totalPage &&
        this.isApiOk &&
        newVal
      ) {
        this.getSearchBatch();
      }
    },
  },
};
</script>

<style lang="scss">
@import "./style/reset.module.scss";
@import "./style/rwd.module.scss";
</style>

<style lang="scss" scoped>
@import "./style/color.scss";
@import "./style/mixin";

a {
  width: 100%;
  display: inline-block;
}

.container {
  width: 950px;
  min-height: 100vh;
  margin: 0 auto;
}

::v-deep .block {
  width: 100%;
  background-color: $promotion;
  border-radius: 10px;
  margin-bottom: 30px;

  .mainTitle {
    min-height: 60px;
    line-height: 1.5;
    padding: 5px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    @include title(36px, $white);
  }

  .inner {
    background-color: $web_main;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    display: grid;
    gap: 10px;

    &.darkMode {
      background-color: $davy-grey;
    }
  }
}

@media screen and (max-width: 950px) {
  .container {
    width: 100%;
    .bg {
      width: 93%;
      display: block;
    }
  }

  ::v-deep .block {
    width: 93% !important;
    margin: 0 auto 30px auto;
  }

  ::v-deep .inner {
    padding: 10px !important;
  }

  ::v-deep .mainTitle {
    font-size: 2rem !important;
    min-height: unset !important;
  }
}
</style>
